var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-loading',{attrs:{"loading":_vm.bridgeMeta.loading}},[_c('bridge-form',{attrs:{"mode":"edit","bridge":_vm.bridge},on:{"submit":_vm.handleSubmit,"delete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }